//@flow
import * as React from 'react';
import PropTypes from 'prop-types';
import { List } from 'immutable';
import MediaViewerModal from './MediaViewerModal';
import styles from './MediaViewer.scss';
import { stripWarningTags } from 'components/ContentSection/UserGeneratedTextContainer';
import UgcLinkContext, { UgcLinkButton } from 'containers/UgcLinkContext';

const PlayIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 300 300"
    className={styles.mediaViewerListItemButtonPlayIcon}
  >
    <path
      fill="#fff"
      fillOpacity="0.7"
      stroke="#fff"
      strokeWidth="3"
      d="M46.4 283.6c-2.3 0-4.7-.6-6.8-1.8-4.2-2.4-6.7-6.9-6.7-11.7V30.9c0-4.8 2.6-9.3 6.7-11.7 4.2-2.4 9.3-2.4 13.5 0l208.6 119.6c4.2 2.4 6.8 6.9 6.8 11.7s-2.6 9.3-6.8 11.7L53.1 281.8c-2.1 1.2-4.4 1.8-6.7 1.8z"
    />
  </svg>
);

type MediaViewerProps = {
  ugcs: List<*>,
  hideUgcLink?: boolean,
};

type MediaViewerState = {
  modalIsOpen: boolean,
  selectedItemIndex: number,
};

class MediaViewer extends React.Component<MediaViewerProps, MediaViewerState> {
  state = {
    modalIsOpen: false,
    selectedItemIndex: -1,
  };

  static Modal = MediaViewerModal;

  expandImage = (e: SyntheticEvent<HTMLButtonElement>) => {
    this.setState({
      modalIsOpen: true,
      selectedItemIndex: parseInt(
        e.currentTarget.getAttribute('data-item-index'),
        10
      ),
    });
  };

  closeModal = () => {
    this.setState({
      modalIsOpen: false,
      selectedItemIndex: -1,
    });
  };

  render() {
    const { ugcs } = this.props;

    if (ugcs.size === 0) {
      return null;
    }

    const { modalIsOpen, selectedItemIndex } = this.state;
    const selectedUgc = ugcs.get(parseInt(selectedItemIndex, 10));
    const items = ugcs.map((ugc, i) => {
      const { ugctype, urlSet, caption } = ugc;
      let src = '';
      if (ugctype === 'Image') {
        src = urlSet.thumbnail;
      } else if (ugctype === 'Video') {
        src = urlSet.thumbnail;
      }
      let listItemClassName = styles.mediaViewerListItem;

      return (
        <li
          className={listItemClassName}
          key={i}
          aria-label={caption && stripWarningTags(caption)}
        >
          <button
            type="button"
            className={styles.mediaViewerListItemButton}
            onClick={this.expandImage}
            data-item-index={i}
          >
            {ugctype === 'Video' && <PlayIcon />}
            <img src={src} alt="" className={styles.mediaViewerThumbnail} />
          </button>
          {this.props.hideUgcLink !== true && (
            <UgcLinkContext.Consumer>
              {linker => <UgcLinkButton href={linker(ugc)} label="Moderate" />}
            </UgcLinkContext.Consumer>
          )}
        </li>
      );
    });
    const shouldRenderModal = modalIsOpen === true && selectedUgc != null;

    return (
      <React.Fragment>
        <ul className={styles.mediaViewerList}>{items}</ul>
        {shouldRenderModal && (
          <MediaViewerModal
            selectedUgc={selectedUgc}
            onClose={this.closeModal}
          />
        )}
      </React.Fragment>
    );
  }
}

MediaViewer.propTypes = {
  ugcs: PropTypes.instanceOf(List),
};

export default MediaViewer;



// WEBPACK FOOTER //
// ./src/components/ContentSection/MediaViewer/MediaViewer.js